import http from "infra/http";
import { useQuery } from "react-query";

import { PaginateResult } from "core/resources/types/shared";
import {
  RetornoBancariaItemsPaginate,
  RetornoBancarioPaginateFiltro,
} from "../typings";

function useItensRetornosBancarios(filtro: RetornoBancarioPaginateFiltro) {
  const queryResult = useQuery([`/v1/retorno-bancario/itens`], async () => {
    const { data } = await http.get<
      PaginateResult<RetornoBancariaItemsPaginate>
    >(`/v1/retorno-bancario/itens`, {
      params: filtro,
    });

    return data;
  });

  return {
    ...queryResult,
  };
}

export default useItensRetornosBancarios;
